const jobList = {
  backendClass: [
    {
      title: '后端工程师',
      address: 'Hangzhou, China',
      desc: ['2年以上 Java 开发经验，熟练掌握 MVC 编程思想及 Spring 架构', '熟练掌握Web应用开发，具有并发、数据系统设计、研发、调优经验', '熟悉MySQL/MongoDB数据库应用开发', '熟悉Linux环境开发，熟悉常用Shell命令', '对缓存技术（Redis / Memcached等）有较深入的应用及研究', '具有Hadoop / HBase / Spark / Storm / Dubbo 等经验者优先', '责任心强，对技术有执着热情，抗压能力强者优先']
    },
  ],

  androidClass: [
    {
      title: 'Android工程师',
      address: 'Hangzhou, China',
      desc: ['两年以上Android 平台开发经验，熟悉Android框架和各种特性', '扎实的数据结构及算法基础，理解面向对象设计的基本原则，熟悉常用的设计模式', '优秀的学习能力，分析和解决问题的能力和强烈的进取心', '对技术、数据有执念者，我们特别喜欢', '具备良好的沟通能力和团队协作能力', '计算机或相关专业本科及以上学历', '具备良好的英语沟通能力者优先']
    },
  ],

  dataClass: [
    {
      title: '数据科学家',
      address: 'Hangzhou, China',
      desc: ['计算机、统计等相关专业', '对常用的机器学习算法、特征选择方法、数据建模过程有深入理解', '扎实的编程和数学基础', '熟练掌握Matlab、R、Python等任一一种语言', '勤奋踏实，善于分析思考问题，具有优秀的沟通能力、团队合作精神和抗压能力']
    },
    {
      title: '大数据系统开发工程师',
      address: 'Hangzhou, China',
      desc: ['有大数据系统的丰富的使用经验，清晰的知道每种系统的用法，了解核心系统原理', '深入的Java开发经验，了解Python、Scala、Shell等语言', '掌握并熟练使用常用算法和数据结构','认同互联网风格的企业文化，有强烈的求知欲和好奇心','有互联网金融和风控系统的开发经验加分','名校硕士以上学历或海归背景加分']
    },
    {
      title: '数据分析师',
      address: 'Hangzhou, China',
      desc: ['本科及以上学历，计算机、统计、数学相关专业者优先','较强的分析和解决问题的能力, 对数据敏感，至少熟练一门脚本语言（Shell/Python等）','熟悉Mysql/Oracle/Hive等数据库，有数据挖掘及数据清洗经验者优先','熟练掌握数理统计分析等，具备较强的数学建模能力，能够针对实际的问题建立数学模型','沟通能力强']
    },
  ],

  productClass: [
    {
      title: '金融产品经理',
      address: 'Hangzhou, China',
      desc: ['大学本科及以上学历，2年以上个人信贷类金融产品设计工作经验','具备优秀的金融产品设计能力，能够独立完成金融产品的算费、还款日设计、期限结构、账户设计等系统设计工作','具备与风控团队的沟通协调能力']
    },
    {
      title: '风控产品经理',
      address: 'Hangzhou, China',
      desc: ['3年以上产品经理经验，1年以上负责征信、数据、信贷风控类产品设计经验','学习钻研能力强，对产品有好奇心，能够主动学习思考行业规律和产品体系','具有独立完成客户需求分析、市场调研和撰写需求规格说明书的经验','有较强的分析和逻辑思维能力，有数据分析经验或技术开发经验者优先','有强烈的责任心和沟通、协调意识，能够明确提出和跟进项目中遇到的各种问题','有一定的英语能力，能够用英语进行书面交流和撰写业务文档','富有创业精神，充满激情，乐于接受挑战']
    },
  ],

  otherClass: [

  ]
}

export default jobList;


// WEBPACK FOOTER //
// ./src/util/job-list.js